import { CustomerGroupType } from '../enums';

export class CustomerGroupDto {
  public payments: number[];
  public promotions: number[];
  public taxRateShift: number;
  public priceLevel: number;
  public takeaway: boolean;
  public id: number;
  public name: string;
  public type: CustomerGroupType;
}
